var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkButton = function SvgIconLinkButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.663 7.383a.75.75 0 1 0 0 1.5h5.924l-6.674 6.674a.75.75 0 1 0 1.06 1.06l6.676-6.675v5.926a.75.75 0 1 0 1.499 0V7.383z"
  })));
};
export default SvgIconLinkButton;